import React from 'react';
import './Reward.scss';
import {
	clearUserInfo, getAuthorize,
	getUserOrderList, historyOfPush,
	isNotLoggedIn,
	showTipsAlert,
	showToast, createShareUrl, showPassWordLogin, analysisSubmit,
} from "../../asstes/js/IntegratedProcessing";
import {
	getRandom, getSessionCache, getTimeString,
	isInBocApp,
	isInWeChat,
	showLogin,
} from "../../asstes/js/Utils";
import {getAllProductList, openReward} from "../../asstes/js/Rescource";
import FloatNavigation from "../../components/FloatNavigation/FloatNavigation";
import OrderComponent from "../../components/OrderComponent/OrderComponent";
import ShareOtherComponent from "../../components/ShareOtherComponent/ShareOtherComponent";
import ShareAlertModule from "../../components/ShareAlertModule/ShareAlertModule";
import BannerComponent from "../../components/BannerComponent/BannerComponent";
import Config from "../../asstes/js/Config";

class Reward extends React.Component {
	state = {
		getRandomIdx: getSessionCache('selectMouse') || getRandom(0, 5), // || getRandom(0, 5)
		isLogin: false,
		times: 0,
		orderList: null,
		userShareReward: null, // 用户分享记录
		showReadEnvelope: false,
		showOrderList: false,
		showShareModules: false, // 打开分享的大弹窗-分享海报|分享微信提示
		createPostUrl: null, // 生成海报的url
		onlyBocApp: false, // 仅展示中行APP分享
		loginBgPic: false, // 登录后的背景图
		noLoginBgPic: false, // 未登录的背景图
	}

	UNSAFE_componentWillMount() {
		0 && showPassWordLogin()
		this.getBocAuthorize()
	}

	// 中行授权
	getBocAuthorize() {
		if (getAuthorize('reward')) {
			this.showAlertOrderList()
		}
	}

	// 获取用户的可领奖品
	async showAlertOrderList() {
		if (isNotLoggedIn()) {
			showLogin()
			return
		}
		let res = await getAllProductList()
		if (res.success) {
			let data = res.datas
			if ((getTimeString() < getTimeString(data.countBeginTime)) || (getTimeString() < getTimeString(data.dateBegin))) {
				showTipsAlert('活动还没有开始哦~', '我知道了')
				return
			}
			if ((getTimeString() > getTimeString(data.countEndTime)) || (getTimeString() > getTimeString(data.dateEnd))) {
				showTipsAlert('活动已结束<br/><br/>感谢您的关注<br/>敬请期待下一次活动', '我知道了')
				return
			}
		} else if (res.errorCode === '410015' || res.errorCode === '410003') {
			clearUserInfo()
			showLogin()
			return false
		} else if (res.errorCode === '400037') { // 方案未开始
			showTipsAlert('活动还没有开始哦~', '我知道了')
			return false
		} else if (res.errorCode === '400038') { // 方案已过期
			showTipsAlert('活动已结束<br/><br/>感谢您的关注<br/>敬请期待下一次活动', '我知道了')
			return false
		} else if (res.errorCode === '434006') { // 查询中行接口失败,请稍后再试
			showTipsAlert('当前太多人排队啦，请稍后重试', '我知道了')
			return false
		} else { // res.errorCode === '500'
			showToast('服务器异常，请稍后重试！')
			return false
		}
		getUserOrderList({
			state: '0,-1',
			needWait: 1500
		}).then(res => {
			if (res.code === '200') {
				if (res.arr.length > 0) {
					let userPayReward = res.arr.filter(item => item.state === '0')
					let userShareReward = res.arr.filter(item => item.state === '-1')
					if (userPayReward.length > 0) {
						this.setState({
							orderList: userPayReward[0],
							userShareReward: userShareReward,
							isLogin: true
						}, () => {
							this.openReward()
						})
					} else {
						this.toggleOrder()
					}
				} else {
					let oldTime = this.state.times
					this.setState({
						times: oldTime + 1
					}, () => {
						if (oldTime < 1) {
							this.showAlertOrderList()
						} else {
							this.showIndexAlert()
						}
					})
				}
			} else { // res.code === '500'
				showToast('服务器异常，请稍后重试!')
			}
		})
	}

	// 展示首页弹窗
	showIndexAlert() {
		// let events = {
		// 	msg: '我们还没有查询到您的福利哦！如您已完成支付，可以刷新本页面再次查询。如您未支付，请返回活动首页参与活动再来领奖哦！',
		// 	btnText: '去首页',
		// 	methods: {
		// 		vm: this,
		// 		name: 'linkIndex',
		// 		needClose: true
		// 	}
		// }
		// showTipsAlert(events['msg'], events['btnText'], events['methods'])
		this.toggleOrder()
	}

	// 开奖
	openReward = () => {
		console.log(Config);
		let {orderList, userShareReward} = this.state
		if (!isInWeChat() && orderList.rdefType === "PRODUCT") {
			showToast('您有待领取的礼品，赶紧领取吧', 3000)
			this.toggleOrder()
			return
		}
		if (isNotLoggedIn()) {
			showLogin()
			return;
		}
		console.log(orderList);
		if (orderList.state === '0') {
			openReward({
				sendNo: orderList.sendNo
			}).then(res => {
				const errorCode = res.errorCode
				if (res.success) { // 领奖成功
					if (userShareReward.length > 0) {
						showToast('您有待领取的礼品，赶紧领取吧', 3000)
						this.toggleOrder()
					// 	userSelectArrReceive(this, [], userShareReward)
						return
					}
					let isRed = orderList.rdefType === "PRODUCT"
					if (isRed) { // <span class="max-font">1<span class="yuan">元</span></span>
						showTipsAlert(`恭喜你获得<span class="max-font">${orderList.rdetailName}</span><span class="yuan">元</span>微信红包`, null, null, {
							showFire: true
						})
					} else {
						showTipsAlert(`恭喜你获得<span class="max-font">${orderList.rdetailName}</span><span class="yuan">个</span>中银豆积分`, null, null, {
							showFire: true
						})
					}
					analysisSubmit('openPrize')
				} else if (errorCode === '420006') { // 奖品已过期
					showTipsAlert(`您的奖品超过时间未领取，已过期`)
				} else if (errorCode === '436001') { // 奖品校验失
					showTipsAlert(`领取失败`, '我知道了')
				} else if (errorCode === '420005') { // 用户领取过
					showTipsAlert(`您已经领取过了哦~`)
				} else if (errorCode === '434005') { // 中行没关注
					let isRed = orderList.rdefType === "PRODUCT"
					let name = isRed ? '微信红包' : '中银豆积分'
					let yuan = isRed ? '元' : '个'
					// showTipsAlert(`请关注“中国银行广东分行”回复“1分拆锦盒”领取奖励吧~`)
					/* {
						name: 'linkFollow', url: Config.template.followUrl
					} */
					showTipsAlert(`<p style="margin-top: -10%">恭喜你获得[${name}]</p><br>
		<p class="max-font">${orderList.rdetailName}<span class="yuan">${yuan}</span></p>
		<br/>请关注“中国银行广东分行”回复“锦盒”或“新年快乐”领取奖励`, null, null, {
						topImg: '-13%'
					})
					this.setState({
						showReadEnvelope: true
					})
				} else if (errorCode === '434006') { // 查询中行接口失败,请稍后再试
					showTipsAlert('当前太多人排队啦，请稍后重试', '我知道了')
				} else if (errorCode === '410015') { // 用户校验失败
					clearUserInfo()
					showLogin()
				} else {
					showToast('服务器异常，请稍后重试')
				}
			})
		} else {
			showTipsAlert('您已经领取过了哦~')
		}
	}

	// 邀请好友参与
	shareBtn = () => {
		// 打开微信弹窗
		this.setState({
			showShareModules: true
		})
	}

	// 去首页
	linkIndex() {
		historyOfPush('/index')
	}

	// 显示订单
	toggleOrder = async (bol = null) => {
		if (isNotLoggedIn()) {
			showLogin()
			return
		}
		let res = await getAllProductList()
		if (res.success) {
			let data = res.datas
			if ((getTimeString() < getTimeString(data.countBeginTime)) || (getTimeString() < getTimeString(data.dateBegin))) {
				showTipsAlert('活动还没有开始哦~', '我知道了')
				return
			}
			if ((getTimeString() > getTimeString(data.countEndTime)) || (getTimeString() > getTimeString(data.dateEnd))) {
				showTipsAlert('活动已结束<br/><br/>感谢您的关注<br/>敬请期待下一次活动', '我知道了')
				return
			}
		} else if (res.errorCode === '410015' || res.errorCode === '410003') {
			clearUserInfo()
			showLogin()
			return false
		} else if (res.errorCode === '400037') { // 方案未开始
			showTipsAlert('活动还没有开始哦~', '我知道了')
			return false
		} else if (res.errorCode === '400038') { // 方案已过期
			showTipsAlert('活动已结束<br/><br/>感谢您的关注<br/>敬请期待下一次活动', '我知道了')
			return false
		} else if (res.errorCode === '434006') { // 查询中行接口失败,请稍后再试
			showTipsAlert('当前太多人排队啦，请稍后重试', '我知道了')
			return false
		} else { // res.errorCode === '500'
			showToast('服务器异常，请稍后重试！')
			return false
		}
		this.setState({
			showOrderList: bol !== null ? bol : !this.state.showOrderList
		})
	}

	createPost = () => {
		let {defaultLink} = createShareUrl()
		this.setState({
			createPostUrl: defaultLink
		})
	}

	hideShareModule = () => {
		this.setState({
			showShareModules: false
		})
	}

	hidePost = () => {
		this.setState({
			createPostUrl: ''
		})
	}

	loginImgBgLoad = (e) => {
		let name = e.target.name
		this.setState({
			[name]: true
		})
	}

	render() {
		const bg1 = require('../../asstes/img/reveive/receive-bg1.jpg')
		const successFire = require('../../asstes/img/reveive/fire.gif')
		const bg2 = require('../../asstes/img/reveive/reveive-bg2.jpg')
		const bg3 = require('../../asstes/img/reveive/reveive-bg3.jpg')
		const receiveBtn = require('../../asstes/img/reveive/receive-btn.png')
		// const shareWxBtn = require('../../asstes/img/reveive/share-wx-btn.png')
		// const konWBtn = require('../../asstes/img/reveive/receive-know-btn.png')
		const receiveDetail = require('../../asstes/img/reveive/receive-detail.jpg')
		const receiveDetail1 = require('../../asstes/img/reveive/receive-detail-1.jpg')
		const receiveDetail2 = require('../../asstes/img/reveive/receive-detail-2.jpg')
		const receiveDetail3 = require('../../asstes/img/reveive/receive-detail-3.jpg')
		const {orderList, isLogin, getRandomIdx, showReadEnvelope, showOrderList, createPostUrl, showShareModules, loginBgPic, noLoginBgPic} = this.state
		const billTop = require('../../asstes/img/bill/bill-top.jpg')
		const billBottom = require('../../asstes/img/bill/bill-bottom.jpg')
		const billBtn = require('../../asstes/img/bill/bill-btn.png')
		const successMouseArr = [
			require('../../asstes/img/reveive/receive-success/receive-success-mouse1.png'),
			require('../../asstes/img/reveive/receive-success/receive-success-mouse2.png'),
			require('../../asstes/img/reveive/receive-success/receive-success-mouse3.png'),
			require('../../asstes/img/reveive/receive-success/receive-success-mouse4.png'),
			require('../../asstes/img/reveive/receive-success/receive-success-mouse5.png'),
			require('../../asstes/img/reveive/receive-success/receive-success-mouse6.png')
		]
		const successTextArr = [
			require('../../asstes/img/reveive/receive-success/success-text1.png'),
			require('../../asstes/img/reveive/receive-success/success-text2.png'),
			require('../../asstes/img/reveive/receive-success/success-text3.png'),
			require('../../asstes/img/reveive/receive-success/success-text4.png'),
			require('../../asstes/img/reveive/receive-success/success-text5.png'),
			require('../../asstes/img/reveive/receive-success/success-text6.png'),
		]
		const successFontBgArr = [
			require('../../asstes/img/reveive/receive-success/font1.png'),
			require('../../asstes/img/reveive/receive-success/font2.png'),
			require('../../asstes/img/reveive/receive-success/font3.png'),
			require('../../asstes/img/reveive/receive-success/font4.png'),
			require('../../asstes/img/reveive/receive-success/font5.png'),
			require('../../asstes/img/reveive/receive-success/font6.png'),
		]

		const isRedPackage = orderList && orderList.rdefType === "PRODUCT" // 是红包

		return <div className="reward-container">
			{
				isLogin ?
					<>
						{/* 用户登录 */}
						<div className="relative flex-center-center">
							<div className="relative">
								<img name={'loginBgPic'} src={bg1} onLoad={this.loginImgBgLoad} alt=""/>
								{
									loginBgPic ?
										<img className="success-top-bg" src={successFontBgArr[getRandomIdx]} alt=""/>
										: null
								}
							</div>
							{
								loginBgPic ?
									<>
										<img className="success-mouse-bg" src={successFire} alt=""/>
										<div className="success-mouse-logo">
											<img src={successMouseArr[getRandomIdx]} alt=""/>
											<img className="success-text" src={successTextArr[getRandomIdx]} alt=""/>
										</div>
									</> : null
							}
						</div>
						{
							loginBgPic ? <>
								<div style={{position: 'relative'}}>
									<img src={bg2} alt=""/>
									<div className="receive-div flex-center-center">
										{
											!orderList ? null :
												<>
													<div className="reward-name">
														恭喜你获得[{isRedPackage ? '微信红包' : '中银豆积分'}]大奖
													</div>
													<div className="reward-price">
														{/*168.00<span className="reward-logo">元</span>*/}
														{orderList.rdetailName}<span className="reward-logo">{isRedPackage ? '元' : '个'}</span>
													</div>
												</>
										}
										{ // 邀请好友参与
											<img className="receive-btn" src={receiveBtn} onClick={this.shareBtn} alt=""/>
										}
									</div>
								</div>
								<div style={{position: 'relative'}}>
									<img src={bg3} alt=""/>
									<div className={`reward-description flex-center-center ${!isRedPackage ? 'min-font' : ''}`}>
										{
											isRedPackage ?
												'微信红包24小时内领取有效，请按照以下步骤快快领走我！' :
												`请${isInBocApp() ? '打开' : '登录'}中国银行“手机银行APP”>生活>定位广东（深圳除外）>广东专属服务 >”限时抢积分“查看我的中银豆`
										}
									</div>
								</div>
								{ // 是否展示红包
									isRedPackage ? (showReadEnvelope ?
										<img className="reward-detail-img" src={receiveDetail} alt=""/> :
										(isInBocApp() ? <img className="reward-detail-img" src={receiveDetail3} alt=""/> :
											<img className="reward-detail-img" src={receiveDetail1} alt=""/>)) :
										<img className="reward-detail-img" src={receiveDetail2} alt=""/>
								}
							</> : null
						}
						{ // 生成海报
							createPostUrl ? <ShareOtherComponent createPostUrl={createPostUrl} hidePost={this.hidePost}/> : null
						}
						{ // 生成分享弹窗
							showShareModules ? <ShareAlertModule createPost={this.createPost}
							                                     hideShareModule={this.hideShareModule} userCheckIn={true}/> : null
						}
					</> : <>
						{/* 海报 */}
						<img name={'noLoginBgPic'} onLoad={this.loginImgBgLoad} src={billTop} alt="/"/>
						{
							noLoginBgPic ?
								<div className="relative">
									<img src={billBottom} alt="/"/>
									<img className="bill-btn" src={billBtn} onClick={this.linkIndex} alt=""/>
									<div className="reward-banner-ctx">
										<BannerComponent/>
									</div>
								</div> : null
						}
					</>
			}
			<FloatNavigation bounds={'.reward-container'} toggleOrder={this.toggleOrder}/>
			{
				showOrderList ? <OrderComponent toggleOrder={this.toggleOrder}/> : null
			}
			{/* 提前加载图片信息 */}
			<>
				<img style={{width: '1px', height: '1px', opacity: '0'}} src={successMouseArr[getRandomIdx]} alt=""/>
				<img style={{width: '1px', height: '1px', opacity: '0'}} src={require('../../asstes/img/alert/login.png')}
				     alt=""/>
			</>
		</div>
	}
}

export default Reward;
